interface IconProps {
  className?: string;
}

/**
 * Award medal with a checkmark, filled. Inlined because the shared sprite
 * (~/components/Icon) does not include it. The checkmark is stroked in white
 * so it stays legible against the filled medal shape.
 */
const MedalCheckIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden className={className}>
    <path
      d="M17 7C17 10.866 13.866 14 10 14C6.13401 14 3 10.866 3 7C3 3.13401 6.13401 0 10 0C13.866 0 17 3.13401 17 7Z"
      fill="currentColor"
    />
    <path
      d="M7.5 7.16667L9.16667 8.83333L12.5 5.5"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.12695 14C7.27468 14.6364 8.59467 15 10 15C11.4053 15 12.7253 14.6364 13.873 14H13.8887L15 20L10 18.3633L5 20L6.11133 14H6.12695Z"
      fill="currentColor"
    />
  </svg>
);

export default MedalCheckIcon;
